/** 浏览器控制台筛选：`[wechat-login]` */

const TAG = '[wechat-login]';

export function wechatLoginLog(phase: string, detail?: Record<string, unknown>): void {
  if (detail !== undefined && Object.keys(detail).length > 0) {
    console.info(TAG, phase, detail);
  } else {
    console.info(TAG, phase);
  }
}
